symbolDescriptiveString